import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchApprovedTasks,
  startTask,
  endTask,
  doTaskLater,
} from "../../redux/actions/taskActions";
import { PlusSquare, Loader2 } from "lucide-react";
import moment from "moment";
import DailyTaskPageAttendanceModalPage from "./DailyTaskPageAttendanceModalPage";
import { fetchAttendanceStatus } from "../../redux/actions/attendanceActions";

const DailyTaskPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [endTaskModal, setEndTaskModal] = useState(false);
  const [taskSubmitId, setTaskSubmitId] = useState(null);
  const [taskTrackingId, setTaskTrackingId] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);
  const [loading2, setLoading2] = useState(false);
  console.log("refreshTrigger>>>>>", refreshTrigger);

  // Loading states for different operations
  const [startingTaskId, setStartingTaskId] = useState(null);
  const [endingTask, setEndingTask] = useState(false);
  const [doingLaterTaskId, setDoingLaterTaskId] = useState(null);
  const [locationLoading, setLocationLoading] = useState(false);

  const dispatch = useDispatch();
  const { approvedTasks, loading } = useSelector((state) => state.task);
  const { attendanceStatus } = useSelector((state) => state.attendance || {});
  console.log("attendanceStatus:::::::>>>", attendanceStatus);

  const handleModalClose = (wasSuccessful = false) => {
    setIsModalOpen(false);
    if (wasSuccessful) {
      refreshTasks(); // this will show the new task
    }
  };

  const refreshTasks = () => {
    setIsModalOpen(false);
    setRefreshTrigger((prev) => prev + 1);
  };

  useEffect(() => {
    dispatch(fetchAttendanceStatus());
  }, []);

  useEffect(() => {
    setLoading2(true);
    const timer = setTimeout(() => {
      dispatch(fetchApprovedTasks(`approved,ongoing,complete`));
      setLoading2(false);
    }, 1000);

    return () => clearTimeout(timer); // Cleanup the timeout if component unmounts or effect reruns
  }, [refreshTrigger]);

  const toggleModal = () => {
    if (attendanceStatus?.is_attendance_given == 0) {
      alert("Please Clock in first to start your day");
      return;
    }
    setIsModalOpen(!isModalOpen);
  };

  const handleStartTask = async (taskid) => {
    if (attendanceStatus?.is_attendance_given == 0) {
      alert("Please Clock in first to start your day");
      return;
    }

    setStartingTaskId(taskid);
    setLocationLoading(true);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        let obj = {
          id: taskid,
          start_time: moment().format("HH:mm:ss"),
          start_latitude: lat,
          start_longitude: lng,
        };

        try {
          console.log("Starting task with:", obj);
          dispatch(startTask(obj));
          refreshTasks();
        } catch (error) {
          console.error("Error starting task:", error);
        } finally {
          setStartingTaskId(null);
          setLocationLoading(false);
        }
      },
      (error) => {
        console.error("Location error:", error);
        alert("Location access denied.");
        setStartingTaskId(null);
        setLocationLoading(false);
      }
    );
  };

  const handleEndTask = (task) => {
    // Get the current ongoing task tracking ID - this matches React Native logic
    const ongoingTracking = task.task_tracking?.find(
      (tracking) => tracking.status === "ongoing"
    );

    setTaskSubmitId(task.task_submit_id);
    setTaskTrackingId(
      ongoingTracking?.task_tracking_id || task.task_tracking_id
    );
    setEndTaskModal(true);
  };

  const handleDoTaskLater = async (task) => {
    if (window.confirm("Are you sure you want to do this later?")) {
      setDoingLaterTaskId(task.task_submit_id);

      try {
        // Get the current ongoing task tracking ID - this matches React Native logic
        const ongoingTracking = task.task_tracking?.find(
          (tracking) => tracking.status === "ongoing"
        );

        let obj = {
          task_submit_id: task.task_submit_id,
          id: ongoingTracking?.task_tracking_id || task.task_tracking_id,
        };

        console.log("Marking task for later:", obj);
        dispatch(doTaskLater(obj));
        refreshTasks();
      } catch (error) {
        console.error("Error marking task for later:", error);
      } finally {
        setDoingLaterTaskId(null);
      }
    }
  };

  const executeEndTask = async (remark) => {
    setEndingTask(true);
    setLocationLoading(true);

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const lat = position.coords.latitude;
        const lng = position.coords.longitude;

        let obj = {
          id: taskTrackingId,
          task_submit_id: taskSubmitId,
          end_time: moment().format("HH:mm:ss"),
          end_latitude: lat,
          end_longitude: lng,
          task_tracking_remarks: remark,
        };

        try {
          console.log("Ending task with:", obj);
          dispatch(endTask(obj));
          refreshTasks();
        } catch (error) {
          console.error("Error ending task:", error);
        } finally {
          setEndTaskModal(false);
          setEndingTask(false);
          setLocationLoading(false);
        }
      },
      (error) => {
        console.error("Location error:", error);
        alert("Location access denied.");
        setEndTaskModal(false);
        setEndingTask(false);
        setLocationLoading(false);
      }
    );
  };

// Helper function to determine button states - matches React Native logic exactly
  const getButtonStatesForTask = (task) => {
    // Check if any task is currently ongoing across all tasks
    const isAnyTaskOngoing = approvedTasks.some(
      (t) => t.latest_tracking_status === "ongoing"
    );

    // Check if current date is between createTaskDate and endTaskDate
    const currentDate = moment();
    const startDate = moment(task?.createTaskDate);
    const endDate = moment(task?.endTaskDate);

    // Condition 1: Show buttons only if current date is between task dates
    const shouldShowButtons = currentDate.isBetween(
      startDate,
      endDate,
      "day",
      "[]"
    );

    // Additional condition: If task day is ended (has complete status for today), don't show buttons
    const isTodayTaskEnded = task?.task_tracking?.some(
      (tracking) =>
        tracking.status === "complete" &&
        moment(tracking.created_at).isSame(currentDate, "day")
    );

    // Final condition to show buttons: shouldShowButtons is true AND today's task is not ended
    const showButtons = shouldShowButtons && !isTodayTaskEnded;

    // Get current task's tracking status
    const currentTaskStatus = task?.latest_tracking_status;

    // Button states based on conditions - exactly matching React Native logic
    let buttonStates = {};

    // Condition 2: If latest_tracking_status is null, End button should be disabled
    if (currentTaskStatus === null) {
      buttonStates = {
        startButtonDisabled: isAnyTaskOngoing, // Disabled if any other task is ongoing
        startButtonOpacity: isAnyTaskOngoing ? 0.5 : 1,
        endButtonDisabled: true, // Always disabled when status is null
        endButtonOpacity: 0.5,
        doLaterButtonDisabled: true, // Can't do later if not started
        doLaterButtonOpacity: 0.5,
      };
    }
    // Condition 3: If latest_tracking_status is "ongoing", End button visible and Start disabled
    else if (currentTaskStatus === "ongoing") {
      buttonStates = {
        startButtonDisabled: true, // Start disabled when task is ongoing
        startButtonOpacity: 0.5,
        endButtonDisabled: false, // End button enabled
        endButtonOpacity: 1,
        doLaterButtonDisabled: false, // Do later enabled when task is ongoing
        doLaterButtonOpacity: 1,
      };
    }
    // Condition 4: If latest_tracking_status is "complete" but shouldShowButtons true, Start enabled
    else if (currentTaskStatus === "complete" && shouldShowButtons === true) {
      buttonStates = {
        startButtonDisabled: false, // Start enabled
        startButtonOpacity: 1,
        endButtonDisabled: true, // End disabled
        endButtonOpacity: 0.5,
        doLaterButtonDisabled: true, // Do later disabled
        doLaterButtonOpacity: 0.5,
      };
    }
    // For other statuses
    else {
      buttonStates = {
        startButtonDisabled:
          isAnyTaskOngoing || currentTaskStatus === "complete",
        startButtonOpacity:
          isAnyTaskOngoing || currentTaskStatus === "complete" ? 0.5 : 1,
        endButtonDisabled: true,
        endButtonOpacity: 0.5,
        doLaterButtonDisabled: true,
        doLaterButtonOpacity: 0.5,
      };
    }

    return { showButtons, buttonStates };
  };

  // Loading spinner component
  const LoadingSpinner = ({ size = 16, className = "" }) => (
    <Loader2 className={`animate-spin ${className}`} size={size} />
  );

  return (
    <div className="relative w-full h-screen bg-slate-800 text-white flex flex-col pb-6 mb-10">
      {/* Location Loading Overlay */}
      {locationLoading && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="bg-slate-700 p-6 rounded-lg flex flex-col items-center space-y-3">
            <LoadingSpinner size={32} className="text-sky-400" />
            <p className="text-white text-lg">Getting location...</p>
          </div>
        </div>
      )}

      {/* Task List */}
      <div className="flex-grow overflow-y-auto p-4 space-y-4">
        {loading || loading2 ? (
          <div className="flex flex-col items-center justify-center h-40 space-y-3">
            <LoadingSpinner size={32} className="text-sky-400" />
            <p className="text-center text-gray-300">Loading tasks...</p>
          </div>
        ) : approvedTasks.length === 0 ? (
          <p className="text-center text-gray-300">No Daily Task Found</p>
        ) : approvedTasks && approvedTasks.length > 0 ? (
          approvedTasks.map((task) => {
            // Get button states for this specific task
            const { showButtons, buttonStates } = getButtonStatesForTask(task);

            return (
              <div
                key={task.task_submit_id}
                className={`text-black w-full max-w-md mx-auto rounded-xl p-4 shadow-lg space-y-1 ${
                  task.status === "approved"
                    ? "bg-green-100"
                    : task.status === "pending"
                    ? "bg-red-100"
                    : task.status === "ongoing"
                    ? "bg-yellow-100"
                    : task.status === "complete"
                    ? "bg-green-100"
                    : "bg-red-100"
                }`}
              >
                <p>
                  <strong>Visit Location :</strong> {task.task_name || "N/A"}
                </p>
                <p>
                  <strong>Visit Purpose :</strong> {task.task_title || "N/A"}
                </p>
                <p>
                  <strong>Start Date :</strong>{" "}
                  {moment(task.createTaskDate).format("ddd, MMM D, YYYY")}{" "}
                  {task.start_time}
                </p>
                <p>
                  <strong>End Date :</strong>{" "}
                  {moment(task.endTaskDate).format("ddd, MMM D, YYYY")}{" "}
                  {task.end_time}
                </p>
                <p>
                  <strong>Status :</strong>{" "}
                  <span
                    className={`capitalize ${
                      task.status === "rejected"
                        ? "text-red-600"
                        : "text-green-600"
                    }`}
                  >
                    {task.latest_tracking_status || "Approved"}
                  </span>
                </p>
                <p>
                  <strong>Day :</strong>{" "}
                  <span
                    className={
                      task.latest_tracking_status === "ongoing"
                        ? "text-red-600"
                        : "text-black"
                    }
                  >
                    {task.task_activity}
                  </span>
                </p>

                {/* Display task tracking history */}
                {task?.task_tracking && task.task_tracking.length > 0 && (
                  <div className="mt-2">
                    <p className="font-bold text-sm">Tracking History:</p>
                    {task.task_tracking.map((tracking, trackingIndex) => (
                      <p
                        key={trackingIndex}
                        className="text-xs ml-2"
                      >
                        • {moment(tracking.created_at).format("MMM D, YYYY")} -{" "}
                        {tracking.status.toUpperCase()} - Start: {tracking.start_time}
                        {tracking.end_time
                          ? ` | End: ${tracking.end_time} | Duration: ${tracking.task_duration}`
                          : " (In Progress)"}
                      </p>
                    ))}
                  </div>
                )}

                {/* Show buttons only if showButtons condition is met */}
                {showButtons && (
                  <>
                    <div className="flex gap-3 mt-4">
                      {/* Start Task Button */}
                      <button
                        onClick={() => handleStartTask(task.task_submit_id)}
                        disabled={
                          buttonStates.startButtonDisabled ||
                          startingTaskId === task.task_submit_id ||
                          locationLoading
                        }
                        className={`flex-1 py-2 rounded-md font-semibold transition-colors flex items-center justify-center space-x-2`}
                        style={{
                          backgroundColor: 
                            buttonStates.startButtonDisabled ||
                            startingTaskId === task.task_submit_id ||
                            locationLoading
                              ? "#84cc16" // lime-300 equivalent
                              : "#65a30d", // lime-600 equivalent
                          color: 
                            buttonStates.startButtonDisabled ||
                            startingTaskId === task.task_submit_id ||
                            locationLoading
                              ? "#6b7280" // gray-500
                              : "white",
                          opacity: buttonStates.startButtonOpacity,
                          cursor: 
                            buttonStates.startButtonDisabled ||
                            startingTaskId === task.task_submit_id ||
                            locationLoading
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        {startingTaskId === task.task_submit_id ? (
                          <>
                            <LoadingSpinner size={16} />
                            <span>Starting...</span>
                          </>
                        ) : (
                          <span>Start Task</span>
                        )}
                      </button>

                      {/* End Task Button */}
                      <button
                        onClick={() => handleEndTask(task)}
                        disabled={
                          buttonStates.endButtonDisabled ||
                          startingTaskId ||
                          locationLoading
                        }
                        className={`flex-1 py-2 rounded-md font-semibold transition-colors`}
                        style={{
                          backgroundColor: 
                            buttonStates.endButtonDisabled ||
                            startingTaskId ||
                            locationLoading
                              ? "#fca5a5" // red-200 equivalent
                              : "#dc2626", // red-600 equivalent
                          color: 
                            buttonStates.endButtonDisabled ||
                            startingTaskId ||
                            locationLoading
                              ? "#6b7280" // gray-500
                              : "white",
                          opacity: buttonStates.endButtonOpacity,
                          cursor: 
                            buttonStates.endButtonDisabled ||
                            startingTaskId ||
                            locationLoading
                              ? "not-allowed"
                              : "pointer",
                        }}
                      >
                        End Task
                      </button>
                    </div>

                    {/* Do it later Button */}
                    <button
                      onClick={() => handleDoTaskLater(task)}
                      disabled={
                        buttonStates.doLaterButtonDisabled ||
                        doingLaterTaskId === task.task_submit_id ||
                        startingTaskId ||
                        locationLoading
                      }
                      className={`w-full mt-2 py-2 rounded-md font-semibold transition-colors flex items-center justify-center space-x-2`}
                      style={{
                        backgroundColor: 
                          buttonStates.doLaterButtonDisabled ||
                          doingLaterTaskId === task.task_submit_id ||
                          startingTaskId ||
                          locationLoading
                            ? "#7dd3fc" // sky-200 equivalent
                            : "#0ea5e9", // sky-500 equivalent
                        color: 
                          buttonStates.doLaterButtonDisabled ||
                          doingLaterTaskId === task.task_submit_id ||
                          startingTaskId ||
                          locationLoading
                            ? "#6b7280" // gray-500
                            : "white",
                        opacity: buttonStates.doLaterButtonOpacity,
                        cursor: 
                          buttonStates.doLaterButtonDisabled ||
                          doingLaterTaskId === task.task_submit_id ||
                          startingTaskId ||
                          locationLoading
                            ? "not-allowed"
                            : "pointer",
                      }}
                    >
                      {doingLaterTaskId === task.task_submit_id ? (
                        <>
                          <LoadingSpinner size={16} />
                          <span>Processing...</span>
                        </>
                      ) : (
                        <span>Do It Later</span>
                      )}
                    </button>
                  </>
                )}
              </div>
            );
          })
        ) : (
          <p className="text-center text-gray-300">
            No approved tasks available
          </p>
        )}
      </div>

      {/* Floating Add Button */}
      <button
        className="absolute bottom-24 right-6 bg-sky-400 rounded-full p-4 shadow-lg z-50 hover:bg-sky-500 transition-colors"
        onClick={toggleModal}
        disabled={locationLoading}
      >
        <PlusSquare className="text-black" size={28} />
      </button>

      {/* Modal for adding new task */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-slate-700 p-6 rounded-lg max-w-md w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-white">Add New Task</h3>
              <button
                onClick={toggleModal}
                className="text-gray-400 hover:text-white text-2xl"
              >
                ×
              </button>
            </div>
            <DailyTaskPageAttendanceModalPage
              onClose={handleModalClose}
              onSuccess={() => {
                setIsModalOpen(false);
                refreshTasks();
              }}
            />

            <button
              onClick={toggleModal}
              className="w-full bg-sky-500 text-white py-2 rounded-md hover:bg-sky-600 mt-4"
            >
              Close
            </button>
          </div>
        </div>
      )}

      {/* End Task Modal */}
      {endTaskModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-slate-800 p-6 rounded-lg max-w-md w-full mx-4">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-white">
                About to end task...
              </h3>
              <button
                onClick={() => !endingTask && setEndTaskModal(false)}
                className="text-gray-400 hover:text-white text-2xl"
                disabled={endingTask}
              >
                ×
              </button>
            </div>

            <div className="space-y-3">
              <button
                onClick={() => executeEndTask("end_daily_task")}
                disabled={endingTask}
                className={`w-full py-3 rounded-md font-semibold transition-colors flex items-center justify-center space-x-2 ${
                  endingTask
                    ? "bg-red-300 text-gray-500 cursor-not-allowed"
                    : "bg-red-500 text-white hover:bg-red-600"
                }`}
              >
                {endingTask ? (
                  <>
                    <LoadingSpinner size={16} />
                    <span>Ending Task...</span>
                  </>
                ) : (
                  <span>End this task</span>
                )}
              </button>

              <button
                onClick={() => executeEndTask("inside")}
                disabled={endingTask}
                className={`w-full py-3 rounded-md font-semibold transition-colors flex items-center justify-center space-x-2 ${
                  endingTask
                    ? "bg-sky-300 text-gray-500 cursor-not-allowed"
                    : "bg-sky-500 text-white hover:bg-sky-600"
                }`}
              >
                {endingTask ? (
                  <>
                    <LoadingSpinner size={16} />
                    <span>Processing...</span>
                  </>
                ) : (
                  <span>Returned to office</span>
                )}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DailyTaskPage;